(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Modals;

    (function (Modals, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Modals, 'DialogLoader')) {
            return;
        }

        /*
         |===========================================================================================================
         | Class definition
         |===========================================================================================================
         */

        /**
         * Handles the loading and displaying of modal dialogs from server.
         *
         * @memberOf Lfl.Modals
         * @lends Lfl.Modals.DialogLoader
         * @constructor
         *
         * @param {string} openDialogUrl Url to retrieve the dialog from server.
         */
        Lfl.Modals.DialogLoader = function (openDialogUrl) {
            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Construction
             |-------------------------------------------------------------------------------------------------------------------
             */

            if(typeof openDialogUrl === 'undefined') {
                throw "The openDialogUrl must not be undefined.";
            }

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Opens the dialog.
             *
             * @param parameters
             * @param {{}} parameters.callbacks
             * @param {function} parameters.callbacks.success
             * @param {function} parameters.callbacks.failure
             * @param {{}} parameters.parameters Parameters that will be sent back to the server.
             */
            this.loadAndOpenDialog = function (parameters) {
                var data = {
                    parameters: parameters.parameters
                };

                $.ajax({
                    type: 'get',
                    url: openDialogUrl,
                    contentType: "application/json",
                    dataType: "html",
                    data: data,
                    success: function (receivedData) {
                        var $data = $(receivedData);
                        var dialog = Lfl.Ajax.ResponseParser.getPrimaryHtmlSections($data)[0];

                        Lfl.Modals.Displayer.appendAndDisplayBootstrapModal(dialog, true);
                        Lfl.Ajax.ResponseParser.moveModals($data);
                        Lfl.Ajax.ResponseParser.moveJavascript($data);

                        if (
                            typeof parameters.callbacks !== 'undefined'
                            && typeof parameters.callbacks.success !== 'undefined'
                        ) {
                            parameters.callbacks.success();
                        }
                    },
                    error: function (receivedData) {
                        console.error("Failed to open dialog! Received:");
                        console.error(receivedData);
                        console.error("--- End of received data ---");

                        Lfl.Ajax.ResponseParser.processErrorResponse(receivedData);

                        if (
                            typeof parameters.callbacks !== 'undefined'
                            && typeof parameters.callbacks.failure !== 'undefined'
                        ) {
                            parameters.callbacks.failure();
                        }
                    }
                });
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

        };
    }(Lfl.Modals = Lfl.Modals || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
